import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CHECKBOX_PROPS } from './types';
import CheckboxDescription from './components/checkbox-description';
import CheckboxControl from './components/checkbox-control';
import { APPEARANCES as PARAGRAPH_APPEARANCES } from '../paragraph/constants';

const Checkbox = ({
  checked,
  defaultChecked,
  description = null,
  disabled = false,
  id,
  label,
  name = null,
  onChange,
  tooltipProps = null,
  value,
  isLabelBold = true,
}) => {
  if (checked !== undefined && defaultChecked !== undefined) {
    throw new Error(`
Checkbox component can be either controlled, or uncontrolled.
If you want it to be controlled - please pass the 'checked',
and update it externally via the 'onChange' callback.
If you want it to be uncontrolled - please pass the 'defaultChecked',
and its updates will be handled by the Tabs component itself.
`);
  }

  const handleChange = (event) => {
    const { checked: isChecked, value: val } = event.target;
    onChange(isChecked, val);
  };

  const classes = classNames('ws-ui-checkbox', {
    'ws-ui-checkbox--disabled': disabled,
  });

  return (
    <div className={classes}>
      <CheckboxControl
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        id={id}
        name={name}
        onChange={handleChange}
        tooltipProps={tooltipProps}
        value={value}
        isLabelBold={isLabelBold}
      >
        {label}
      </CheckboxControl>
      {description && (
        <CheckboxDescription
          appearance={
            disabled ? PARAGRAPH_APPEARANCES.lowEmphasis : PARAGRAPH_APPEARANCES.mediumEmphasis
          }
        >
          {description}
        </CheckboxDescription>
      )}
    </div>
  );
};

Checkbox.propTypes = {
  ...CHECKBOX_PROPS,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Checkbox;
